import React from "react";
import {Card} from "../modules/Organisations/index";

export function OrganisationCardPage(props) {
  return (
    <Card {...props} />
  );
}
